import React from 'react'
import HomeCategoriesItem from './HomeCategoriesItem'

const HomeCategoriesList = ({
  categories,
  activeCategory,
  bannerButtonText,
  changeActiveCategory,
  selectCategory,
}) => {
  return (
    <ul className="dealmed-home-categories__list">
      {categories.map((category, index) => {
        return (
          <HomeCategoriesItem
            key={index}
            category={category}
            isActive={activeCategory?.categoryName === category?.categoryName}
            changeActiveCategory={changeActiveCategory}
            selectCategory={selectCategory}
            bannerButtonText={bannerButtonText}
          />
        )
      })}
    </ul>
  )
}

export default HomeCategoriesList
